import React, { Component } from 'react';
//import { withRouter, Redirect } from 'react-router-dom'
import { Button, Form, Input, FormFeedback, Container, Row, Col } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {
  Card,
  CardBody,
  CardImg,
} from 'reactstrap';
import Loading from '../shared/Loading';
import EirButton from '../eir-button/EirButton';
import EirBBInfoResultContainer from '../eir-bbinforesult-container/EirBBInfoResultContainer';

class EirFormContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataUrl: "https://bbinfo-api.eir.ie/subscriber/",
      phoneNumber: '',
      isLoading: false,
      buttonPressed: false,
      notFound: false,
      dataFound: false,
      error: false,
      modal: false,
      dataReady: false,
    };

    this.toggle = this.toggle.bind(this);
    this.jsonReturned = "";

  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }


  handleChange(e) {
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
       this.setState({phoneNumber: e.target.value})
    }
  }

  async getData(fullUrl) {
    this.setState({
      isLoading: true,
    });

    let response = await fetch(fullUrl);
    if (response.status == 404) {
      this.setState({
        isLoading: false,
        notFound: true,
        dataFound: false,
      });
    }
    if (response.status == 200) {
      this.setState({
        isLoading: false,
        notFound: false,
        dataFound: true,
      });

    }
    if (this.state.dataFound) {
      var json = await response.json();
      let jsonString = JSON.stringify(json);
      this.jsonReturned = jsonString;
      //document.cookie = "bbinfo=" + jsonString;
      this.setState({
        isLoading: false,
        dataReady: true,
      });
      //window.location.assign("result");
      //this.props.history.push('result');
    }
  }


  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      buttonPressed: true,
    });
    var fullUrl = this.state.dataUrl + this.state.phoneNumber;
    if(this.state.phoneNumber){
      this.getData(fullUrl);
    }
    else{
      this.setState({
        isLoading: false,
        notFound: true,
        dataFound: false
      })
    }
  }

  render() {
    if (this.state.error) {
      return (<h2 className="text-center">Error</h2>);
    }
    //else if (this.state.isLoading) {
    //  return (<Loading className="m-5" />);
    //}
    else if (this.state.dataReady) {
      //else if (this.state.dataFound) {

      //this.setState({
      //  dataFound: false,
      //})
      return <EirBBInfoResultContainer jsonString={this.jsonReturned} />
    } else {

      const initialState = (this.state.notFound && this.state.buttonPressed);

      return (
        <Container className="d-flex flex-column justify-content-center align-items-center">
          <Row><h4 className="mt-3 text-dark">Broadband line information</h4></Row>
          <Row><p className="px-1">To see the broadband speeds for your line, please enter your details below.</p></Row>
          <Row className="mb-4">
            <Card className="eir-form mb-4 mb-md-5 mb-lg-6">
              <CardBody>
                <Row>
                  <h4 className="font-weight-bold mx-auto d-block mb-0">Enter your home phone number or</h4>
                </Row>
                <Row m-0 pb-4>
                  <h4 className="font-weight-bold pb-4 mx-auto d-block">broadband line number</h4>
                  <CardImg className="m-0 p-0 float-right eir-nn-imgsize-20"
                    src="/.galleries/eir/nn/help-icon.png"
                    onClick={this.toggle}
                  />

                </Row>
                <Row>
                  <div>
                    <Modal size="lg" isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                      <ModalHeader toggle={this.toggle}>How to find your broadband line number</ModalHeader>
                      <ModalBody>
                        <img className="pb-3 mx-auto d-block" src="/.galleries/eir/nn/help-icon.png" />
                        <p>If you do not have a fixed telephone number or if no result is returned for your telephone number
                        , you may have a broadband number with a prefix of 888x. You can view this number in the account
                          information section of your bill. Use this number to check your line.</p>
                        <Container className="bill-image d-flex flex-column justify-content-center align-items-center">
                        </Container>

                      </ModalBody>
                      <ModalFooter>
                        <Container className="d-flex flex-column justify-content-center align-items-center">
                          <Button aria-label="Close form" className="text-center" color="primary" onClick={this.toggle}>Close</Button>
                        </Container>
                      </ModalFooter>
                    </Modal>
                  </div>
                </Row>

                <Form onSubmit={this.handleSubmit} noValidate={true}>
                  <Row className="pb-4 no-gutters">
                    <Col xs="12">
                      <Input className="eir-nn-phone-input"
                        type="text"
                        name="phoneNumber"
                        id="phone"
                        title="Please enter a phone number"
                        invalid={initialState}
                        value={this.state.phoneNumber}
                        required
                        onChange={(e) => this.handleChange(e)}
                      />
                      <FormFeedback>
                        <p className="m-0 p-0 text-center">Sorry, the number that you have entered</p>
                        <p className="m-0 p-0 text-center">has not been found or is invalid</p>
                      </FormFeedback>
                    </Col>
                  </Row>
                  <EirButton className="mt-3"
                    type="button"
                    text="CHECK"
                    name="Submit"
                    value="Submit"
                  />
                </Form>
              </CardBody>
            </Card>
          </Row>
        </Container >
      );
    }
  }
}

export default EirFormContainer;
